import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';    
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';           
import { Rank } from '@ascschool/model/category/rank.model';
import { DegreeService } from '@ascschool/services/category/degree.service';
import { Degree } from '@ascschool/model/category/degree.model';
import { SystemUserService } from '@ascschool/services/user/system-user.service';

@Component({
  selector: 'app-cap-nhat-mat-khau',
  templateUrl: './cap-nhat-mat-khau.component.html',
  styleUrls: ['./cap-nhat-mat-khau.component.scss']
})
export class CapNhatMatKhauComponent implements OnInit {
  @Input() listId: any;
  passwordForm: FormGroup;
  isEditMode = false; 
  errorMsg: string;
  isDisabled = false; 
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    private route: ActivatedRoute,
    public utilsService: UtilsService,
    private systemUserService: SystemUserService,
    private fb: FormBuilder,
  ) {
  }

  ngOnInit() {
    this.passwordForm = new FormGroup({
      password: new FormControl('', Validators.required),
      repassword: new FormControl('', Validators.required),
    }); 
  }
  
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  update() {
    
    if (this.passwordForm.valid) {
      if (this.passwordForm.controls['password'].value == this.passwordForm.controls['repassword'].value) {
        this.passwordForm.controls['password'].setValue(this.utilsService.md5Encode(this.passwordForm.controls['password'].value).toUpperCase());
        this.passwordForm.controls['repassword'].setValue(this.utilsService.md5Encode(this.passwordForm.controls['repassword'].value).toUpperCase());
        this.systemUserService.updateMultiplePassword({ listSystemUserId: this.listId, newPassword: this.passwordForm.controls['password'].value }).subscribe(res => {
          if (res.statusCode == 0) {
            this.utilsService.notifyResponse(res);
            this.close();
          } else {
            this.utilsService.notifyResponse(res);
          }
        });
      } else {
        this.msg.warning('Xác nhận phải giống mật khẩu mới!');
      }
    } else {
      this.msg.warning('Vui lòng nhập trường bắt buộc!');
    }

  }
}
